import React, { useEffect } from "react";
import { object, array } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { getAdSlots } from "../../ads/utils";
import Breadcrumbs from "../../molecules/story-page-items/story-info/bread-crumbs";
import HeroImage from "../../molecules/story-page-items/story-info/hero-image";
import StoryGrid from "../../molecules/story-page-items/story-grid";
import ReadMoreStories from "../../molecules/story-page-items/read-more-stories";
import { DfpComponent } from "../../ads/dfp-component";
import { ArrowOpinionCollection } from "../../collection-templates/arrow-rows";
import { OldStoryMessage } from "../../atoms/old-stories-message";

import "./photo-story.m.css";

const PhotoStory = ({ story, relatedStories, collection }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const adsConfig = get(qtState, ["config", "ads-config"], {});
  const enableAds = get(adsConfig, ["dfp_ads", "enable_ads"]);
  const adConfig = get(adsConfig, ["slots", "story_page_ads"], {});
  const loadAdsSynchronously = get(adsConfig, ["dfp_ads", "load_ads_synchronously"], null);
  const adSlots = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots"], {}));

  useEffect(() => {
    if (enableAds) {
      const sectionSlug = get(story, ["sections", 0, "slug"], "NA");
      getAdSlots({
        path: adConfig.ad_unit,
        size: adConfig.sizes,
        id: `story-card-${story.id}-ad`,
        qtState,
        viewPortSizeMapping: adConfig.view_port_size_mapping,
        storySectionSlug: sectionSlug,
        refreshAdUnit: true,
        loadAdsSynchronously,
        delayPeriod: 4000,
      });
    }
  }, [story]);

  return (
    <div className="story-grid">
      <OldStoryMessage story={story} />
      <div className="container" styleName="photo-story-wrapper">
        <div styleName="hero-image-wrapper" data-test-id="hero-image-wrapper">
          <Breadcrumbs story={story} />
          <HeroImage story={story} />
        </div>
        <StoryGrid story={story} relatedStories={relatedStories} />
        <DfpComponent
          adStyleName="ad-slot-size-970x90"
          className="ad-slot-size-970x90"
          id="story-leader-board-3"
          path={adSlots.story_leader__ad3.ad_unit}
          size={adSlots.story_leader__ad3.sizes}
          viewPortSizeMapping={adSlots.story_leader__ad3.view_port_size_mapping}
        />
        <ReadMoreStories />
        {collection && (
          <div styleName="opinion-wrapper">
            <ArrowOpinionCollection collection={collection} />
          </div>
        )}
      </div>
    </div>
  );
};

PhotoStory.propTypes = {
  story: object,
  relatedStories: array,
  collection: object,
};

export { PhotoStory };
